<template>
	<transition name="error-fade">
		<div class="error-box container border-l">
			<p>
				{{ message }}
			</p>
			<span class="close-button" @click="removeError(index)">X</span>
		</div>
	</transition>
</template>

<script>
import { mapActions } from "vuex";
export default {
	props: ["message", "index"],
	methods: {
		...mapActions(["removeError"]),
	},
};
</script>

<style lang="scss" scoped>
.error-box {
	padding: 12px;
	width: 100%;
	background-color: #fff3;
	position: relative;
	.close-button {
		position: absolute;
		top: 12px;
		right: 12px;
		cursor: pointer;
	}
	p {
		font-size: 12px;
	}
}
</style>
